import { EpochRewardListItemType, EpochRewardRecordApiType } from "@/types";
import { toFiniteNumber } from "./epochRewards";

const toSafeString = (value: unknown) => {
  return typeof value === "string" ? value : "";
};

const getFiniteNumberOrDefault = (value: unknown, fallback: number) => {
  return toFiniteNumber(value) ?? fallback;
};

const getStatus = (reward: EpochRewardRecordApiType) => {
  const status = toSafeString(reward.status).trim().toLowerCase();
  return status || "unknown";
};

export const normaliseEpochRewardsList = (
  rewards: EpochRewardRecordApiType[] | null | undefined
) => {
  const safeRewards = Array.isArray(rewards) ? rewards : [];

  return safeRewards.map((reward) => {
    const epochId = toSafeString(reward.epoch_id).trim();
    const status = getStatus(reward);
    const id = epochId || "unknown";
    const epochRewardsEmission = getFiniteNumberOrDefault(reward.total_reward, 0);
    const pendingCount = getFiniteNumberOrDefault(reward.pending_count, 0);
    const sentCount = getFiniteNumberOrDefault(reward.sent_count, 0);
    const failedCount = getFiniteNumberOrDefault(reward.failed_count, 0);
    const skippedCount = getFiniteNumberOrDefault(reward.skipped_count, 0);
    const totalDevices = getFiniteNumberOrDefault(reward.total_devices, 0);
    const totalGpus = getFiniteNumberOrDefault(reward.total_gpus, 0);
    const nominatedFromCounts = pendingCount + sentCount + failedCount + skippedCount;
    const nominated = nominatedFromCounts > 0 ? nominatedFromCounts : totalGpus;
    const succeeded = sentCount > 0 ? sentCount : status === "completed" ? nominated : 0;
    const failed = failedCount > 0 ? failedCount : status === "failed" ? nominated : 0;
    const href = epochId ? `/explorer/epochs/${epochId}` : undefined;
    const epochStart = toSafeString(reward.epoch_start).trim();
    const epochFinish = toSafeString(reward.epoch_finish).trim();
    const gpuDevices = getFiniteNumberOrDefault(reward.gpu_devices, 0);
    const cpuDevices = getFiniteNumberOrDefault(reward.cpu_devices, 0);
    const epochSignature = toSafeString(reward.epoch_signature).trim();
    const burnAmount = getFiniteNumberOrDefault(reward.burn_amount, 0);
    return {
      id,
      status,
      epochId,
      epochStart,
      epochFinish,
      epochRewardsEmission,
      totalGpus,
      nominated,
      succeeded,
      failed,
      href,
      gpuDevices,
      cpuDevices,
      totalDevices,
      pendingCount,
      sentCount,
      failedCount,
      skippedCount,
      epochSignature,
      burnAmount
    } as EpochRewardListItemType;
  });
};
